<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">设备名称：</span>
        <el-input v-model="search.bigDeviceName" :size="size" clearable placeholder="请输入设备名称"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">设备类型：</span>
        <el-select v-model="search.bigType" placeholder="请选择设备类型" clearable>
            <el-option
                v-for="item in optionsType"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
            </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">设备状态：</span>
        <el-select v-model="search.bigState" placeholder="请选择设备状态" clearable>
            <el-option label="在线" value="1"></el-option>
            <el-option label="离线" value="2"></el-option>
        </el-select>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
        <el-button icon="el-icon-upload2" v-if="showButton('export')" @click="exportBigData">导出Excel</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bigDeviceName" label="设备名称" align="center" ></el-table-column>
        <el-table-column prop="bigDeviceModel" label="规格型号" align="center" ></el-table-column>
        <el-table-column prop="bigNumber" label="设备编号" align="center" ></el-table-column>
        <el-table-column prop="bigTypeName" label="设备类型" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bigPosition" label="安装位置" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bigState" label="设备状态" align="center">
            <template #default="{row}">
                <div>{{row.bigState ===1?'在线':row.bigState ===2?'离线':''}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="realName" label="责任人" align="center"></el-table-column>
        <el-table-column prop="supplierName" label="供应商" align="center"></el-table-column>
        <el-table-column prop="keyCabinet" label="钥匙柜编号" align="center"></el-table-column>
        <el-table-column prop="useLife" label="使用年限" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="400">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('preview')" @click="seeProp(row)">查看</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="codeQR(row)">设备标识牌</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="goPrints(row)">打印</el-button>
            <el-button class="delete_btn" size="mini"  v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle === true ? '新增大型生产设备' :asyncTitle === false ?'修改大型生产设备':'大型生产设备详情'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="45%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="设备名称：" prop="bigDeviceName">
          <el-input v-model="ruleForm.bigDeviceName" :size="size" clearable placeholder="请输入设备名称" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="规格型号：" prop="bigDeviceModel">
          <el-input v-model="ruleForm.bigDeviceModel" :size="size" clearable placeholder="请输入规格型号" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="设备编号：" prop="bigNumber">
          <el-input v-model="ruleForm.bigNumber" :size="size" clearable placeholder="请输入设备编号" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="设备类型：" prop="bigType">
          <el-select v-model="ruleForm.bigType" placeholder="请选择设备类型" :disabled="disabled">
                <el-option
                v-for="item in optionsType"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="安装位置：" prop="bigPosition">
          <el-input v-model="ruleForm.bigPosition" :size="size" clearable placeholder="请输入安装位置" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="设备状态：" prop="bigState">
          <el-select v-model="ruleForm.bigState" placeholder="请选择设备状态" clearable :disabled="disabled">
            <el-option label="在线" :value="1"></el-option>
            <el-option label="离线" :value="2"></el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="设备管理员联系方式：" prop="adminPhone">
            <el-input v-model="ruleForm.adminPhone" :size="size" clearable placeholder="请输入联系电话" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="购买时间：" prop="purchaseTime">
            <el-date-picker
                v-model="ruleForm.purchaseTime"
                type="date"
                :disabled="disabled"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择购买时间">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="供应商：" prop="supplierId">
          <el-select v-model="ruleForm.supplierId" placeholder="请选择供应商" :disabled="disabled">
                <el-option
                v-for="item in optionsSuppliers"
                :key="item.id"
                :label="item.supplierName"
                :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="使用年限：" prop="useLife">
            <el-input v-model="ruleForm.useLife" :size="size" clearable placeholder="请输入使用年限" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="钥匙柜编号：" prop="keyCabinet">
            <el-input v-model="ruleForm.keyCabinet" :size="size" clearable placeholder="请输入钥匙柜编号" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="责任人：" prop="userId">
          <el-select v-model="ruleForm.userId" placeholder="请选择责任人" :disabled="disabled" @change="backPhone">
                <el-option
                    v-for="item in optionsUser"
                    :key="item.userId"
                    :label="item.realName"
                    :value="item.userId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="责任人联系方式：" prop="responsiblePerson">
          <el-input v-model="ruleForm.responsiblePerson" :size="size" clearable placeholder="请输入责任人联系方式" disabled="true"></el-input>
        </el-form-item>
        <!-- <el-form-item label="联系电话：" prop="snCode">
            <el-input v-model="ruleForm.snCode" :size="size" clearable placeholder="请输入联系电话" :disabled="disabled"></el-input>
        </el-form-item> -->
        <el-form-item label="备注：" prop="bigNotes">
            <el-input v-model="ruleForm.bigNotes" :size="size" type="textarea" :rows="2" clearable placeholder="请输入备注" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="使用登记证：">
            <upload-image :file-list="imageList"  @delectImage="delectImage" :disabled="disabled">
                <template #info>
                    <span>支持jpg、png、gif格式文件</span>
                </template>
            </upload-image>
        </el-form-item>
        <el-form-item label="检验报告：" prop="files">
          <upload-file :file-list.sync="ruleForm.files" :disabled="disabled">
                <template #info>
                    <span>点击上传文件，支持xls、xlsx、ppt、doc、docx、pdf格式</span>
                </template>
          </upload-file>
        </el-form-item>
        <el-form-item label="设备使用条件：" >
            <div >
                <el-radio-group v-model="ruleForm.safetyCode" :disabled="disabled">
                    <el-radio :label="1">无</el-radio>
                    <el-radio :label="2">安全码为绿色</el-radio>
                    <el-radio :label="3">安全码为黄色</el-radio>
                </el-radio-group>
                <el-radio-group v-model="ruleForm.isCertificate" :disabled="disabled">
                    <el-radio :label="1">无</el-radio>
                    <el-radio :label="2">定人定机</el-radio>
                    <el-radio :label="3">具备特种作业证书</el-radio>
                    <el-radio :label="4">特种作业证书在有限期内</el-radio>
                </el-radio-group>
            </div>
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="asyncTitle===true||asyncTitle===false">
        <el-button  @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="prop_dialog sign_dialog"
      title="设备标识牌"
      :close-on-click-modal="false"
      :visible.sync="signboardVisible"
      width="820px">
      <div class="sign_main">
        <div class="sign_headers">
            <div class="sign_logo">
                <img :src="`${baseUrl}${userConfig === 'dev' ? '' : '/htapi'}/materials/steelPrint/test?bigDeviceId=${rowDatas&&rowDatas.bigDeviceId}&type=1`" style="width:100%;height:100%">
            </div>
            <div class="sign_titles">设备标识牌</div>
        </div>
        <div class="sign_contents">
          <div class="sign_rows">
              <div class="sign_contents_row">
                <div class="sign_row_text">设备名称</div>
                <div class="sign_row_datas">{{rowDatas&&rowDatas.bigDeviceName}}</div>
              </div>
              <div class="sign_contents_row" style="margin-left:25px">
                <div class="sign_row_text">编号</div>
                <div class="sign_row_datas">{{rowDatas&&rowDatas.bigNumber}}</div>
              </div>
          </div>
          <div class="sign_rows">
              <div class="sign_contents_row">
                <div class="sign_row_text">规格型号</div>
                <div class="sign_row_datas">{{rowDatas&&rowDatas.bigDeviceModel}}</div>
              </div>
              <div class="sign_contents_row" style="margin-left:25px">
                <div class="sign_row_text">生产厂家</div>
                <div class="sign_row_datas">{{rowDatas&&rowDatas.supplierName}}</div>
              </div>
          </div>
          <div class="sign_rows">
              <div class="sign_contents_row">
                <div class="sign_row_text">设备状态</div>
                <div class="sign_row_datas">{{rowDatas&&rowDatas.bigState===1?'在线':'离线'}}</div>
              </div>
              <div class="sign_contents_row" style="margin-left:25px">
                <div class="sign_row_text">责任人</div>
                <div class="sign_row_datas">{{rowDatas&&rowDatas.realName}}</div>
              </div>
          </div>
          <div class="sign_rows">
              <div class="sign_contents_row">
                <div class="sign_row_text">设备管理员联系方式</div>
                <div class="sign_row_datas">{{rowDatas&&rowDatas.adminPhone}}</div>
              </div>
              <div class="sign_contents_row" style="margin-left:25px">
                <div class="sign_row_text">责任人联系方式</div>
                <div class="sign_row_datas">{{rowDatas&&rowDatas.responsiblePerson}}</div>
              </div>
          </div>
        </div>
        <div class="sign_footers">
          <div class="sign_footers_logo">
              <img src="../../assets/logos.png" style="width:100%;height:100%">
          </div>
          <div class="sign_footers_titles">中铁十四局集团房桥有限公司胶东分公司</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import UploadImage from '../../components/uploadImage.vue'
import UploadFile from '../../components/uploadFile';
import { throttle, changeSize,downFiles } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    components:{
       UploadImage,
       UploadFile
    },
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        disabled:false,//是否禁止点击
        imageList:[],//上传的图片
        dataList: [], //设备管理信息列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        signboardVisible:false,//设备标识牌
        baseUrl: process.env.VUE_APP_BASE_URL,
        userConfig: process.env.VUE_APP_OUT_PUT_DIR,
        rowDatas:null,//一行数据
        ruleForm: {
            files:[]
        }, // 按钮表单
        rules: {
          bigDeviceName: [{
            required: true,
            message: '请输入设备名称',
            trigger: 'blur'
          }],
          bigDeviceModel: [{
            required: true,
            message: '请输入规格型号',
            trigger: 'blur'
          }],
          bigType: [{
            required: true,
            message: '请选择设备类型',
            trigger: 'change'
          }],
          bigNumber: [{
            required: true,
            message: '请输入设备编号',
            trigger: 'blur'
          }],
          bigPosition: [{
            required: true,
            message: '请输入安装位置',
            trigger: 'blur'
          }],
          bigState: [{
            required: true,
            message: '请选择设备状态',
            trigger: 'change'
          }],
          purchaseTime: [{
            required: true,
            message: '请选择购买时间',
            trigger: 'change'
          }],
          supplierId: [{
            required: true,
            message: '请选择供应商',
            trigger: 'change'
          }],
          useLife: [{
            required: true,
            message: '请输入使用年限',
            trigger: 'blur'
          }],
          keyCabinet: [{
            required: true,
            message: '请输入钥匙柜编号',
            trigger: 'blur'
          }],
          adminPhone: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          },{
            pattern:
              /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }],
        },
        optionsType:[],//设备类型
        optionsSuppliers:[],//供应商
        optionsUser:[],//负责人
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }else{
            this.$set(this.ruleForm,'files',[])
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllTypes()
      that.getAllSuplier()
      that.getAllPersons()
    },
    methods: {
    //设备标识牌
    codeQR(row){
      this.rowDatas = row
      //  downLoadQRDetails(row.bigNumber,row.bigDeviceId,1,'/materials/steelPrint/test')
      this.signboardVisible = true
    },
    //回显责任人联系方式
    backPhone(val){
      let arr = this.optionsUser.find(item => item.userId == val)
      this.$set(this.ruleForm,'responsiblePerson',arr.phone)
    },
    //打印二维码
    goPrints(row){
      const link = document.createElement('a');
      link.id = `link`;
      link.href = `printpipe://4,${row.bigDeviceId}`
      link.click()
    },
    //查看按钮
    seeProp(row){
        this.disabled = true
        this.asyncTitle = 1;
        this.asyncVisible = true;
        this.imageList = []
        this.$api.Device.detailsBigDevice({bigDeviceId: row.bigDeviceId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
                this.$set(this.ruleForm, 'files', res.data.tbigPaths.filter(iten=>iten.fileType ===2).map((item, index) => {
                    const type = item.filePath.split('.');
                    return {
                        id: index + 1,
                        type: type[type.length - 1],
                        name: item.filePathName,
                        url: item.filePath
                    }
                }))
                res.data.tbigPaths.filter(iten=>iten.fileType ===1).map(item=>{
                    this.imageList.push({
                        id: this.imageList.length + 1,
                        url:`https://htpipe.thhy-tj.com/${item.filePath}`,
                        name:item.filePathName,
                        nameImg:item.filePathName
                    })
                })
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
    //获得所有人员
    getAllPersons(){
        this.$api.Engineer.getPersonsList({}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsUser = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
    //获取供应商信息
    getAllSuplier(){
        let params = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Supplier.searchSupplier(params).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsSuppliers = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
    // 转圈圈
    functionLoading() {
        this.loadingView = this.$loading({
            lock: true,
            text: '请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    },
    //导出Excel
    exportBigData(){
        this.functionLoading();
        let params  = Object.assign({},this.search)
        this.$api.Device.exportBigDatas(params).then(res => {
            downFiles(res, '大型生产设备信息', 'xls')
            this.loadingView.close()
        })
        .catch(() => {
          this.loadingView.close();
        })
    },
    //删除上传图片
    delectImage(item){
        let uploadId = item.id
        this.imageList.splice(this.imageList.findIndex(itm => itm.id === uploadId),1)
        this.$message.success("删除成功!")
    },
    //获取设备类型
      getAllTypes(){
        let params = {
            pageNum: 1,
            pageSize: 100000000,
            dictType:9
        }
        this.$api.Dictionary.searchDictionary(params).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsType = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.Device.searchBigDevice(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
        this.imageList = []
        this.disabled = false
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.disabled = false
        this.imageList = []
        this.$api.Device.detailsBigDevice({bigDeviceId: row.bigDeviceId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
                this.$set(this.ruleForm, 'files', res.data.tbigPaths.filter(iten=>iten.fileType ===2).map((item, index) => {
                    const type = item.filePath.split('.');
                    return {
                        id: index + 1,
                        type: type[type.length - 1],
                        name: item.filePathName,
                        url: item.filePath
                    }
                }))
                res.data.tbigPaths.filter(iten=>iten.fileType ===1).map(item=>{
                    this.imageList.push({
                        id: this.imageList.length + 1,
                        url:`https://htpipe.thhy-tj.com/${item.filePath}`,
                        name:item.filePathName,
                        nameImg:item.filePathName
                    })
                })
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Device.deleteBigDevice({bigDeviceId: row.bigDeviceId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            let arrTitle = []
            this.imageList&&this.imageList.forEach(item=>{
                arrTitle.push(item.name)
            })
            params.pictures = arrTitle
            params.files = params.files&&params.files.map(item => {
               return item.url
            });
            this.$api.Device.insertBigDevice(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            let arrTitle = []
            this.imageList&&this.imageList.forEach(item=>{
                arrTitle.push(item.name)
            })
            params.pictures = arrTitle
            params.files = params.files&&params.files.map(item => {
               return item.url
            });
            this.$api.Device.updateBigDevice(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
.sign_dialog{
  /deep/.el-dialog__body{
    padding: 20px;
  }
}
.sign_main{
  width: 100%;
  height: 500px;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  .sign_headers{
    height: 127px;
    background-color: rgba(21, 56, 118, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .sign_logo{
      width: 80px;
      height: 80px;
      position: absolute;
      left: 20px;
    }
    .sign_titles{
      letter-spacing: 10px;
      font-size: 71px;
      font-weight: bold;
      color: rgba(255, 255, 255, .94);
    }
  }
  .sign_contents{
    flex: 1;
    padding: 30px 15px;
    background:url("../../assets/sign_bg.png") no-repeat;
    background-size: 100% 100%;
    background-position: center;

    .sign_rows{
      display: flex;
      justify-content: space-between;
      padding-bottom: 25px;
      .sign_contents_row{
        width: 50%;
        display: flex;
        border-bottom: 1px solid rgba(208, 208, 208, 1);

        .sign_row_text{
          flex: none;
          font-size: 23px;
          color: rgba(27, 26, 22, 1);
          font-weight: 400;
          padding-bottom: 5px;
        }
        .sign_row_datas{
          flex: 1;
          padding-left: 10px;
          font-size: 23px;
        }
      }
    }
  }
  .sign_footers{
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    .sign_footers_logo{
      width: 39px;
      height: 42px;
      margin-right: 10px;
    }
    .sign_footers_titles{
      font-size: 16px;
      font-weight: 400;
      color: rgba(50, 44, 48, 1);
      letter-spacing: 3px;
    }
  }
}
</style>